import React from 'react';
import styles from './StatCard.module.scss';

const StatCard = React.memo(({ value, label, variant = 'primary', colSize = 3, className = '' }) => (
  <div className={`col-md-${colSize} mb-3 ${className}`}>
    <div className={`card border-0 shadow-sm ${styles.card}`}>
      <div className="card-body text-center">
        <h2 className={`${styles.value} text-${variant}`}>{value}</h2>
        <div className={`card-title ${styles.label}`}>{label}</div>
      </div>
    </div>
  </div>
));

StatCard.displayName = 'StatCard';

export default StatCard;
